export default {
  namespaced: true,
  state: {
    glassesSectionData: {
      section: '',
      groupedTags: {},
      vendors: [],
      categories: []
    },
    sunglassesSectionData: {
      section: '',
      groupedTags: {},
      vendors: [],
      categories: []
    }
  },
  mutations: {
    setGlassesSectionData (state, data) {
      state.glassesSectionData = data
    },
    setSunglassesSectionData (state, data) {
      state.sunglassesSectionData = data
    }
  },
  getters: {
    getOfType: (state) => (type) => {
      return state[`${type}SectionData`]
    }
  },
  actions: {
    setGlassesSectionData ({ commit }, data) {
      commit('setGlassesSectionData', data)
    },
    setSunglassesSectionData ({ commit }, data) {
      commit('setSunglassesSectionData', data)
    }
  }
}
